import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=52c67948&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c67948')) {
      api.createRecord('52c67948', component.options)
    } else {
      api.reload('52c67948', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=52c67948&", function () {
      api.rerender('52c67948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/repair/repairManagement/confirm.vue"
export default component.exports